export default __webpack_public_path__ + "static/media/parameters-gear.dffc5a89.svg";